module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_vis-5fe123351490c72ca4cbacd5224d3694.jpg";